import MiniChat from './MiniChat';

export default MiniChat;
